"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveViewNotaryHandoffStatus = void 0;
/** An accepted Live View share moving from the aven.com tab into notary: PENDING from the forward until the notary tab picks it up, then ATTACHED. */
var LiveViewNotaryHandoffStatus;
(function (LiveViewNotaryHandoffStatus) {
    LiveViewNotaryHandoffStatus["PENDING"] = "PENDING";
    LiveViewNotaryHandoffStatus["ATTACHED"] = "ATTACHED";
})(LiveViewNotaryHandoffStatus || (exports.LiveViewNotaryHandoffStatus = LiveViewNotaryHandoffStatus = {}));
